import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/DoramaCard.module.css';

const DoramaCard = ({ id, slug, slug_id, image, title, rating, mdl_rating, kinopoisk_rating, year, genres, status, fluid = false }) => {
  const maxGenres = 2;
  const displayGenres = genres.slice(0, maxGenres);

  const link = slug && slug_id ? `/dorama/${slug}--${slug_id}` : `/dorama/${id}`;
  const hasPoster = Boolean(image) && !image.endsWith('no-poster') && !image.includes('no-poster');
  const displayRating = rating || mdl_rating || kinopoisk_rating;
  const [isPosterLoaded, setIsPosterLoaded] = useState(false);
  const [hasPosterError, setHasPosterError] = useState(false);

  const showNoPoster = !hasPoster || hasPosterError;

  return (
    <Link to={link} className={`${styles.cardWrapper} ${fluid ? styles.cardWrapperFluid : ''}`}>
      <div className={styles.imageContainer}>
        <div className={styles.card}>
          {hasPoster && !hasPosterError && (
            <img
              src={image}
              alt={title}
              width={220}
              height={330}
              className={`${styles.posterImage} ${isPosterLoaded ? styles.posterImageVisible : ''}`}
              loading="lazy"
              decoding="async"
              onLoad={() => setIsPosterLoaded(true)}
              onError={() => setHasPosterError(true)}
            />
          )}

          {showNoPoster && (
            <div className={styles.noPoster}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <path d="M21 15l-5-5L5 21"/>
              </svg>
              <span className={styles.noPosterText}>Нет постера</span>
            </div>
          )}
          {status === 'ongoing' && (
            <div className={styles.statusBadge}>ВЫХОДИТ</div>
          )}
          {displayRating && (
            <div className={styles.ratingBadge}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
              {displayRating}
            </div>
          )}
        </div>
      </div>

      <div className={styles.cardInfo}>
        <h3 className={styles.cardTitle}><span className={styles.cardTitleText}>{title}</span></h3>
        <div className={styles.cardMeta}>
          <span className={styles.metaText}>{year} {displayGenres.join(', ')}</span>
        </div>

      </div>
    </Link>
  );
};

export default DoramaCard;
